import {
  createSelector,
} from 'reselect';

import type {
  VideosRequestOrder,
} from '../types';

import {
  getResourceMappedList,
} from './resources';
import {
  sortByDate,
} from './utils';

export const getVideos = (order: VideosRequestOrder) => createSelector(
  getResourceMappedList('videos', 'searchResults'),
  videos => videos.sort(sortByDate('created_at', order === 'oldest')),
);
